import {BREAK_POINTS} from './settings';
import pcAddIshover from './module/pcAddIshover';

(function () {

  window.addEventListener('DOMContentLoaded', function(e) {
		if ( window.innerWidth >= BREAK_POINTS.gtTAB) {
			document.querySelector('meta[name="viewport"]').setAttribute('content', 'width=1100');
		}
    pcAddIshover();

		$('.ey-wrapper a').off();
		$('.ey-wrapper a').on('click', function() {
			var href = $(this).attr('href');
			if(href.match(/^#/) && $(href).length > 0) {
				e.preventDefault();
				$('html, body').animate({ scrollTop: $(href).offset().top - $('#header').height() }, 800);
			}
		});

		const jsBtns = document.querySelectorAll('.js-win');

		[].forEach.call(jsBtns, (btn) => {
			btn.onclick = function(e) {
				e.preventDefault();
				window.open(this.href, "_blank", "width=600,height=600");
			}
		})
	});

})();
